import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        comments: window.laravel.comments,
        fullComment: [],
        showComment: false,
    },
    mutations: {
        setFullComment: (state, comment) => {
            state.fullComment = comment;
        },
        setShowComment: (state, show) => {
            state.showComment = show;
        },
    },
    actions: {
        openComment: ({state, commit}, comment) => {
            commit('setFullComment', comment);
            commit('setShowComment', true);
        },
        closeComment: ({commit}) => {
            commit('setShowComment', false);
        },
    },
});

